import type { ColorFrom } from '@tencent/workbench';
import type { FormService, NumberInputFrom, AngleFrom } from '@tencent/wb-ext-form';
import type { IOptions, IReportInfo } from '@framework/workbench/drawer/report';
import type { IBaseToolbarFeature } from './base-toolbar-interface';
import { IMultiDiffValue } from '../../drawer/constants';
import { IInputParams } from '@src/slide/application/service/drawer-input-manager/drawer-handler';

export interface IBaseDrawerFeature extends IBaseToolbarFeature {
    readonly formService: FormService;
    readonly tdwDrawerConstMap: any;
    readonly numberInputFromMap: any;
    readonly imageType: string;
    getPropertyMenu();
    getSelectModel();
    checkSelectType(): ESelectType;
    updateProps(
        id: string, value, onlyChangeUI?: boolean, onlyPreview?: boolean,
        reportInfo?: IReportInfo,
    );
    isMultiOrGroup(): boolean;
    isMultiModel(): boolean;
    isEmptyModel(): boolean;
    isMultiDiffValue(key: string);
    getAlphaFromColor(color: string): number;
    isGifOrSvg(): boolean;
    isGif(): boolean;
    tdwDrawerReport(formItemKey: string, options?: IOptions, onlyChangeUI?: boolean);
    tdwDrawerReportColor(formItemKey: string, from: ColorFrom | number, onlyChangeUI?: boolean);
    tdwDrawerReportAngle(formItemKey: string, from?: AngleFrom, value?: number, onlyChangeUI?: boolean);
    tdwDrawerReportNumberInput(
        reportId: string, options?: IOptions,
        from?: NumberInputFrom, onlyChangeUI?: boolean,
    );
    isTable(): boolean;
    isConnector(): boolean;
    isBackground(): boolean;
    getRgbaColor(color: string, opacity: number);
    getColorOptions(value: string);
    getShownValue(key: string, value: Record<string, number>): number | IMultiDiffValue;
    getValidValue(value, from?: string, max?: number, min?: number);
    /**
     * 根据设置的精确度修正value
     * @param shownValue 展示的值
     * @param toFixed 精确度
     */
    modifyShownValue(shownValue: number | '', toFixed: number): number | '',
    /**
     * 输入框组件是否仅更新UI
     * @returns
     */
    isInputOnlyChangeUI(): boolean;
    /**
     * 带滑块或者旋转盘的输入框组件是否仅更新UI
     * @param dragEnd 是否拖拽结束
     * @returns
     */
    isInputOnlyChangeUIWithDrag(dragEnd?: boolean): boolean;
    getInputParams(): IInputParams;
}

// 选择元素类型
export enum ESelectType {
    SHAPE_OR_IMAGE_OR_CONNECTOR = 1,    // 选择形状或图片或连接线
    GROUP_NO_CHILD = 2, // 选择组合，但组合无子元素
    MULTY_SLIDE_OR_GROUP_HAS_CHILDREN = 3,  // 多选slide或选择组合有子元素
    NO_SLIDE_OR_OTHER = 4,  // 未选择slide或其他情况
}
